<template>
  <div class="layout-default" :class="{ 'layout-default--full-bleed': fullBleed }">
    <!-- The session screen carries its own chrome - the toolbar island sits at
         the very top of the frame and the logo lives in the session bar - so the
         app header would be a second, competing header. -->
    <header v-if="!fullBleed" class="layout-header">
      <DigolaLogo />
      <span v-if="sessionStore.practiceName" class="layout-header__practice">
        {{ sessionStore.practiceName }}
      </span>
    </header>
    <main>
      <RouterView />
    </main>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import DigolaLogo from '@/components/common/DigolaLogo.vue'
import { useSessionStore } from '@/stores/session'

const route = useRoute()
const sessionStore = useSessionStore()

const fullBleed = computed(() => route.meta.fullBleed === true)
</script>

<style scoped>
.layout-default {
  min-height: 100vh;
  background: var(--background);
}

.layout-default--full-bleed > main {
  height: 100vh;
}

.layout-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1.5rem;
  background: #fff;
  border-bottom: 1px solid var(--primary-20);
}

.layout-header__practice {
  font-size: 0.875rem;
  color: var(--primary-dark);
  font-weight: 500;
}
</style>
